import React from "react";
import { useSelector } from "react-redux";
import { TOOL_TEMPLATE } from "../constant/common";
import { useTemplateSetting } from "../hooks/useCompanySettings";
import { annualClosePricesSelector, instrumentsIndexerSelector } from "../store/slice/trade";
import { classNames } from "../utils";
import { HighChartsColumnQuadrata, HighChartsColumnVictor } from "./HighCharts";
import { i18n } from "@euroland/libs";

const AnnualClosePrices = () => {
  const annualPrices = useSelector(annualClosePricesSelector);
  const instrumentsIndexer = useSelector(instrumentsIndexerSelector);
  const template = useTemplateSetting();

  return (
    <>
      {annualPrices.annualClosePrices.length > 0 && !annualPrices.isAllLessTwoYearAnnualClosePrices && (
        <div className="annual-close-prices">
           <h2 className="annual-close-prices--title">{i18n.translate("annualClosePrices")}</h2>
          <p className="annual-close-prices--note">{i18n.translate("annualClosePricesNote")}</p>
          <div
            className={classNames("annual-close-prices--content", {
              "annual-close-prices--row": annualPrices.annualClosePrices.length > 1,
            })}
          >
            {annualPrices.annualClosePrices.map(item => {
              return (
                <div key={item.instrumentId} className="annual-close-prices--chart">
                  {template === TOOL_TEMPLATE.victor ? (
                    <HighChartsColumnVictor
                      data={item}
                      tickerName={instrumentsIndexer[item.instrumentId].ticker}
                      marketCode={instrumentsIndexer[item.instrumentId].marketAbbreviation}
                      marketName={instrumentsIndexer[item.instrumentId].marketName}
                      currencyCode={
                        item.currency ? item.currency : instrumentsIndexer[item.instrumentId].currencyCode
                      }
                    />
                  ) : (
                    <HighChartsColumnQuadrata
                      data={item}
                      tickerName={instrumentsIndexer[item.instrumentId].ticker}
                      marketCode={instrumentsIndexer[item.instrumentId].marketAbbreviation}
                      marketName={instrumentsIndexer[item.instrumentId].marketName}
                      currencyCode={
                        item.currency ? item.currency : instrumentsIndexer[item.instrumentId].currencyCode
                      }
                      isSingle={annualPrices.annualClosePrices.length === 1}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default AnnualClosePrices;
